/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useEffect } from 'react';

// local imports
import './AdminDashboard.css';
import AdminSidebar from './AdminSidebar';
import AdminTopbar from './AdminTopbar';
import Dashboard from './Dashboard';
import Clients from './Clients';
import Providers from './Providers';
import AddProvider from './AddProvider';
import ReplaceProvider from './ReplaceProvider';
import ProviderPayments from './ProviderPayments';
import Audits from './Audits';
import Coupons from './Coupons';
import Payments from './Payments';
import Sessions from './Sessions';
import Refunds from './Refunds';
import GiftVouchers from './GiftVouchers';
import Forms from './Forms';
import FormQuestions from './FormQuestions';
import DemoUsers from './DemoUsers';
import Settings from './Settings';
import ProviderSubscriptionPlans from './ProviderSubscriptionPlans';
// import OrganisationSubscriptionPlans from './OrganisationSubscriptionPlans';
// import ApproveOrganisation from './ApproveOrganisation';
import ApproveProvider from './ApproveProvider';
import ServiceRequests from './ServiceRequests';
import Services from './Services';
import ViewService from './ViewService';
import AddService from './AddService';
import EditService from './EditService';
import ClaimCounsellorProfileRequests from './ClaimCounsellorProfileRequests';
import AddCounselorProfileIndividual from './AddCounselorProfileIndividual';
import EditCounsellorProfileIndividual from './EditCounsellorProfileIndividual';
import AddCounsellorSpreadsheet from './AddCounsellorSpreadsheet';
import ScrapedCounsellorProfiles from './ScrapedCounsellorProfiles';
import Transactions from './Transactions';
import FAQs from './FAQs';
import Policies from './Policies';
import ProviderForms from './ProviderForms';
import ProviderFormQuestions from './ProviderFormQuestions';
import ProviderFormResponse from './ProviderFormResponse';
import AddOrganization from './AddOrganization';
import PsychometricOrganizations from './PsychometricOrganizations';
import PsychometricUsers from './PsychometricUsers';

const AdminDashboard = props => {

    // variable
    let element;
    const path = props.location.pathname.split("/");

    // states
    const [selectedTab, setSelectedTab] = useState(path[path.length - 1]);
    const [selectedForm, setSelectedForm] = useState({ id: "", name: "" });
    const [selectedProviderForm, setSelectedProviderForm] = useState({ id: "", name: "", mode: "" });
    const [stateData, setStateData] = useState({});
    if (props.location.pathname === "/admin/dashboard") {
        element = <Dashboard />;
    } else if (props.location.pathname === "/admin/dashboard/clients") {
        element = <Clients />;
    } else if (props.location.pathname === "/admin/dashboard/providers") {
        element = <Providers />;
    } else if (props.location.pathname === "/admin/dashboard/providerSubscriptionPlans") {
        element = <ProviderSubscriptionPlans />;
        // } else if (props.location.pathname === "/admin/dashboard/organisationSubscriptionPlans") {
        //     element = <OrganisationSubscriptionPlans />;
    } else if (props.location.pathname === "/admin/dashboard/approveProviders") {
        element = <ApproveProvider />
        // } else if (props.location.pathname === "/admin/dashboard/approveOrganisations") {
        //     element = <ApproveOrganisation />;
    } else if (props.location.pathname === "/admin/dashboard/addProviders") {
        element = <AddProvider />;
    } 
     else if (props.location.pathname === "/admin/dashboard/addOrganization") {
         element = <AddOrganization />;
    }
    else if (props.location.pathname === "/admin/dashboard/psychometricOrganizations") {
        element = <PsychometricOrganizations />;
   }
   else if (props.location.pathname === "/admin/dashboard/psychometricUsers") {
    element = <PsychometricUsers />;
}
    else if (props.location.pathname === "/admin/dashboard/replaceProvider") {
        element = <ReplaceProvider />;
    } else if (props.location.pathname === "/admin/dashboard/services") {
        element = <Services history={props.history} />;
    } else if (props.location.pathname === "/admin/dashboard/viewService") {
        element = <ViewService history={props.history} location={props.location} />;
    } else if (props.location.pathname === "/admin/dashboard/addService") {
        element = <AddService history={props.history} />;
    } else if (props.location.pathname === "/admin/dashboard/editService") {
        element = <EditService history={props.history} location={props.location} />;
    } else if (props.location.pathname === "/admin/dashboard/serviceRequests") {
        element = <ServiceRequests />;
    } else if (props.location.pathname === "/admin/dashboard/audits") {
        element = <Audits />;
    } else if (props.location.pathname === "/admin/dashboard/sessions") {
        element = <Sessions />;
    } else if (props.location.pathname === "/admin/dashboard/refunds") {
        element = <Refunds />;
    } else if (props.location.pathname === "/admin/dashboard/coupons") {
        element = <Coupons />;
    } else if (props.location.pathname === "/admin/dashboard/counsellorPayments") {
        element = <ProviderPayments />;
    } else if (props.location.pathname === "/admin/dashboard/payments") {
        element = <Payments />
    } else if (props.location.pathname === "/admin/dashboard/giftVouchers") {
        element = <GiftVouchers />;
    } else if (props.location.pathname === "/admin/dashboard/forms") {
        element = <Forms setSelectedForm={(form) => openFormQuestions(form)} />;
    } else if (props.location.pathname === "/admin/dashboard/formQuestions") {
        element = <FormQuestions gotoForms={() => gotoForms()} selectedForm={selectedForm} />;
    } else if (props.location.pathname === "/admin/dashboard/demoUsers") {
        element = <DemoUsers />;
    } else if (props.location.pathname === "/admin/dashboard/settings") {
        element = <Settings />;
    } else if (props.location.pathname === "/admin/dashboard/claimCounsellorProfileRequests") {
        element = <ClaimCounsellorProfileRequests />
    } else if (props.location.pathname === "/admin/dashboard/scrapedCounsellorProfiles") {
        element = <ScrapedCounsellorProfiles history={props.history} stateData={stateData} setStateData={setStateData} />
    } else if (props.location.pathname === "/admin/dashboard/addCounsellorProfileIndividual") {
        element = <AddCounselorProfileIndividual history={props.history} />
    } else if (props.location.pathname === "/admin/dashboard/editCounselorProfileIndividual") {
        element = <EditCounsellorProfileIndividual stateData={stateData} setStateData={setStateData} />
    } else if (props.location.pathname === "/admin/dashboard/addCounsellorSpreadsheet") {
        element = <AddCounsellorSpreadsheet history={props.history} />
    } else if (props.location.pathname === "/admin/dashboard/transactions") {
        element = <Transactions history={props.history} />
    } else if (props.location.pathname === "/admin/dashboard/faqs") {
        element = <FAQs history={props.history} />
    } else if (props.location.pathname === "/admin/dashboard/policies") {
        element = <Policies history={props.history} />
    } else if (props.location.pathname === "/admin/dashboard/providerForms") {
        element = <ProviderForms setSelectedForm={(form) => openProviderFormQuestions(form)} />;
    } else if (props.location.pathname === "/admin/dashboard/providerFormQuestions") {
        element = <ProviderFormQuestions gotoForms={() => gotoProviderForms()} selectedForm={selectedProviderForm} />;
    } else if (props.location.pathname === "/admin/dashboard/providerFormResponses") {
        element = <ProviderFormResponse gotoForms={() => gotoProviderForms()} selectedForm={selectedProviderForm} />;
    } else {
        element = <Dashboard />;
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        if (selectedTab === "dashboard") {
            props.history.push('/admin/dashboard');
        } else {
            props.history.push('/admin/dashboard/' + selectedTab);
        }
        document.getElementById("root").classList.value = "";
    }, [selectedTab]);

    const openFormQuestions = (form) => {
        setSelectedForm(form);
        setSelectedTab("formQuestions");
    }

    const gotoForms = () => {
        setSelectedForm({ id: "", name: "" });
        setSelectedTab("forms");
    }

    const openProviderFormQuestions = (form) => {
        setSelectedProviderForm(form);
        if (form.mode === "question") {
            setSelectedTab("providerFormQuestions");
        } else if (form.mode === "response") {
            setSelectedTab("providerFormResponses");
        }
    }

    const gotoProviderForms = () => {
        setSelectedProviderForm({ id: "", name: "", mode: "" });
        setSelectedTab("providerForms");
    }

    // use Effects
    useEffect(() => {
        setTimeout(() => {
            document.getElementById("root").classList.value = "";
        }, [300])
        return () => {
            setSelectedTab();
            document.getElementById("root").classList.value = "container container-fluid";
        }
    }, []);

    return (
        <div id="dashboardContainer">
            <AdminTopbar />
            <div id="layoutSidenav">
                <AdminSidebar setSelectedTab={setSelectedTab} />
                <div id="layoutSidenav_content">
                    {element}
                    <footer className="py-4 bg-light mt-auto">
                        <div className="container-fluid">
                            <div className="d-flex align-items-center justify-content-between small">
                                <div className="text-muted">Copyright &copy; umangwellness.com 2020 - All rights reserved</div>
                                <div>
                                    <a href="/privacypolicy">Privacy Policy</a>
                                    &middot;
                                    <a href="/termsconditions">Terms &amp; Conditions</a>
                                </div>
                            </div>
                        </div>
                    </footer>
                </div>
            </div>
        </div>
    )

}

export default AdminDashboard;